import React, { Component } from 'react';
import './Star.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar} from '@fortawesome/free-solid-svg-icons';
import CheckboxFilterOption from './CheckboxFilterOption';
import ParameterErrors from '../errors/ParameterErrors';
import Tooltip from './Tooltip';
const{throwNotProvided}=ParameterErrors;
export default class Star extends Component {
	constructor(props){
		super(props)
		const {tooltip}=props;
		this._tooltip = tooltip;
		this._elementRef = React.createRef();
		const {onSelectedChange, stopEventsPropagating}=props;
		this._stopEventsPropagating = stopEventsPropagating?true:false;
		if(!onSelectedChange)throwNotProvided('onSelectedChange');
		this._onSelectedChange=onSelectedChange;
		this._handleClick= this._handleClick.bind(this);
		this._clicking = false;
		this._handleMouseUp = this._handleMouseUp.bind(this);
		this.state = {selected:false};
	}
	componentDidMount(){
		Tooltip.register({element:this._elementRef.current, text:this._tooltip});
	}
	_stopEventPropagation(e){
		if(!e)e=window.event;
		e.stopPropagation&&e.stopPropagation();
		e.preventDefault&&e.preventDefault();
	}
	_handleClick(e){
		if(this._stopEventsPropagating){
			this._stopEventPropagation(e);
		}
		this._clicking = true;
		const selected = !this.state.selected;
		const allow = this._onSelectedChange(selected);
		if(allow===false)return;
		this.setState({selected:selected});
	}
	_handleMouseUp(e){
		if(this._stopEventsPropagating){
			this._stopEventPropagation(e);
		}
		this._clicking = false;
	}
	get selected(){
		return this.state.selected;
	}
	set selected(value){
		if(this._clicking){
			return;
		}
		this.setState({selected:value});
	}
	render() {
		/*
		<div  className="inner">
			<FontAwesomeIcon icon={faStar} />
		</div>*/
		let className = "star";
		if(this.state.selected)
			className+=" selected";
		return (<div ref={this._elementRef} className={className} onClick={this._stopEventPropagation} onMouseDown={this._handleClick} onMouseUp={this._handleMouseUp} onMouseLeave={this._handleMouseUp}>
					<FontAwesomeIcon icon={faStar} />
				</div>)
	}
}
